import {Alias} from '../js/alias.js';
import {ConfigUtils} from '../shared/utils/ConfigUtils';

let layoutConfig = {

    defaults: {
        [Alias.HOME]: {
            importClass: function () {
                return import('./ContentLayout/ContentLayout.js');
            },
            className: 'ContentLayout'
        },

        [Alias.FORWARD_LAYOUT]: {
            importClass: function () {
                return import('./ForwardLayout/ForwardLayout.js');
            },
            className: 'ForwardLayout'
        },

        [Alias.V2_APP]: {
            importClass: function () {
                return import('./NewAppLayout/NewAppLayout.js');
            },
            className: 'NewAppLayout'
        },

        // User
        [Alias.USER_SETTINGS]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.INVITE_COLLABORATORS]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.SCOUTING]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        // Farm
        [Alias.FARM]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.STATUS]: {
            importClass: function () {
                return import('./FarmStatusLayout/FarmStatusLayout.js');
            },
            className: 'FarmStatusLayout'
        },
        [Alias.WEATHER]: {
            importClass: function () {
                return import('./WeatherLayout/WeatherLayout.js');
            },
            className: 'WeatherLayout'
        },
        [Alias.FARM_SETTINGS]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.FARM_LICENSES]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.CROSS_FARM_DASHBOARD]: {
            importClass: function () {
                return import('./CrossFarmDashboardLayout/CrossFarmDashboardLayout.js');
            },
            className: 'CrossFarmDashboardLayout'
        },
        [Alias.DOWNLOAD_HISTORY]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.CONNECTED_APPS]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.WEATHER_STATIONS]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.DATA_ATTRIBUTION]: {
            importClass: function () {
                return import('./UserUtilityLayout/UserUtilityLayout.js');
            },
            className: 'UserUtilityLayout'
        },
        [Alias.MANAGEMENT_ZONES]: {
            importClass: function () {
                return import('./ManagementZonesLayout/ManagementZonesFactory.js');
            },
            className: 'ManagementZonesFactory'
        },
        [Alias.DRAW_MANAGEMENT_ZONES]: {
            importClass: function () {
                return import('./ManagementZonesLayout/ManagementZonesFactory.js');
            },
            className: 'ManagementZonesFactory'
        },
        [Alias.EDIT_MANAGEMENT_ZONES]: {
            importClass: function () {
                return import('./ManagementZonesLayout/ManagementZonesFactory.js');
            },
            className: 'ManagementZonesFactory'
        },
        [Alias.AB_LINES]: {
            importClass: function () {
                return import('./ABLinesLayout/ABLinesLayoutFactory.js');
            },
            className: 'ABLinesLayoutFactory'
        },
        [Alias.DRAW_AB_LINES]: {
            importClass: function () {
                return import('./ABLinesLayout/ABLinesLayoutFactory.js');
            },
            className: 'ABLinesLayoutFactory'
        },
        [Alias.EDIT_AB_LINES]: {
            importClass: function () {
                return import('./ABLinesLayout/ABLinesLayoutFactory.js');
            },
            className: 'ABLinesLayoutFactory'
        },
        [Alias.DRAW_TRAMLINES]: {
            importClass: function () {
                return import('./ABLinesLayout/ABLinesLayoutFactory.js');
            },
            className: 'ABLinesLayoutFactory'
        },
        [Alias.EDIT_TRAMLINES]: {
            importClass: function () {
                return import('./ABLinesLayout/ABLinesLayoutFactory.js');
            },
            className: 'ABLinesLayoutFactory'
        },
        [Alias.FIELD_ENTRIES]: {
            importClass: function () {
                return import('./FieldEntriesLayout/FieldEntriesLayoutFactory.js');
            },
            className: 'FieldEntriesLayoutFactory'
        },
        [Alias.ADD_FIELD_ENTRIES]: {
            importClass: function () {
                return import('./FieldEntriesLayout/FieldEntriesLayoutFactory.js');
            },
            className: 'FieldEntriesLayoutFactory'
        },
        [Alias.EDIT_FIELD_ENTRIES]: {
            importClass: function () {
                return import('./FieldEntriesLayout/FieldEntriesLayoutFactory.js');
            },
            className: 'FieldEntriesLayoutFactory'
        },
        // Field
        [Alias.DRAW]: {
            importClass: function () {
                return import('./FieldDrawLayout/FieldDrawLayout.js');
            },
            className: 'FieldDrawLayout'
        },
        [Alias.BOUNDARY_DETECTION]: {
            importClass: function () {
                return import('./BoundaryDetectionLayout/BoundaryDetectionLayout.js');
            },
            className: 'BoundaryDetectionLayout'
        },
        [Alias.BOUNDARY_DETECTION_SUCCESS]: {
            importClass: function () {
                return import('./FieldCreateSuccessLayout/FieldCreateSuccessLayout.js');
            },
            className: 'FieldCreateSuccessLayout'
        },
        [Alias.FIELD_UPLOAD]: {
            importClass: function () {
                return import('./FieldUploadLayout/FieldUploadLayout.js');
            },
            className: 'FieldUploadLayout'
        },
        [Alias.FIELD_UPLOAD_SUCCESS]: {
            importClass: function () {
                return import('./FieldCreateSuccessLayout/FieldCreateSuccessLayout.js');
            },
            className: 'FieldCreateSuccessLayout'
        },
        [Alias.EDIT_FIELD]: {
            importClass: function () {
                return import('./FieldDrawLayout/FieldDrawLayout.js');
            },
            className: 'FieldDrawLayout'
        },
        [Alias.CREATE]: {
            importClass: function () {
                return import('./FieldCreateLayout/FieldCreateLayout.js');
            },
            className: 'FieldCreateLayout'
        },
        [Alias.DRAW_SUCCESS]: {
            importClass: function () {
                return import('./FieldCreateSuccessLayout/FieldCreateSuccessLayout.js');
            },
            className: 'FieldCreateSuccessLayout'
        },
        [Alias.ASSIGN_CS]: {
            importClass: function () {
                return import('./CropSeasonLayout/CropSeasonLayout.js');
            },
            className: 'CropSeasonLayout'
        },
        [Alias.EDIT_CS]: {
            importClass: function () {
                return import('./CropSeasonLayout/CropSeasonLayout.js');
            },
            className: 'CropSeasonLayout'
        },
        [Alias.TIMING]: {
            importClass: function () {
                return import('./TimingLayout/TimingLayout.js');
            },
            className: 'TimingLayout'
        },

        // Tasks
        [Alias.TASKS]: {
            importClass: function () {
                return import('./TaskListLayout/TaskListLayout.js');
            },
            className: 'TaskListLayout'
        },
        [Alias.TASK_OBSERVATION_CREATE]: {
            importClass: function () {
                return import('./CreateObservationTaskLayout/CreateObservationTaskLayout.js');
            },
            className: 'CreateObservationTaskLayout'
        },
        [Alias.TASK_SPRAYING_CREATE]: {
            importClass: function () {
                return import('./SprayingTaskLayout/SprayingTaskLayout.js');
            },
            className: 'SprayingTaskLayout'
        },
        [Alias.TASK_SPRAYING_EDIT]: {
            importClass: function () {
                return import('./SprayingTaskLayout/SprayingTaskLayout.js');
            },
            className: 'SprayingTaskLayout'
        },
        [Alias.TASK_NUTRITION_CREATE]: {
            importClass: function () {
                return import('./SprayingTaskLayout/SprayingTaskLayout.js');
            },
            className: 'SprayingTaskLayout'
        },
        [Alias.TASK_NUTRITION_EDIT]: {
            importClass: function () {
                return import('./SprayingTaskLayout/SprayingTaskLayout.js');
            },
            className: 'SprayingTaskLayout'
        },
        [Alias.TASK_HERBICIDE_CREATE]: {
            importClass: function () {
                return import('./SprayingTaskLayout/SprayingTaskLayout.js');
            },
            className: 'SprayingTaskLayout'
        },
        [Alias.TASK_HERBICIDE_EDIT]: {
            importClass: function () {
                return import('./SprayingTaskLayout/SprayingTaskLayout.js');
            },
            className: 'SprayingTaskLayout'
        },
        [Alias.TASK_DRONE_FLIGHT_CREATE]: {
            importClass: function () {
                return import('./DroneFlightTaskLayout/DroneFlightTaskLayout.js');
            },
            className: 'DroneFlightTaskLayout'
        },
        [Alias.TASK_SCOUTING_CREATE]: {
            importClass: function () {
                return import('./ScoutingTaskLayout/ScoutingTaskLayout.js');
            },
            className: 'ScoutingTaskLayout'
        },
        [Alias.TASK_SCOUTING_EDIT]: {
            importClass: function () {
                return import('./ScoutingTaskLayout/ScoutingTaskLayout.js');
            },
            className: 'ScoutingTaskLayout'
        },

        // Fields
        [Alias.FIELDS]: {
            importClass: function () {
                return import('./FieldsLayout/FieldsLayout.js');
            },
            className: 'FieldsLayout'
        },
        
        // Shop
        [Alias.SHOP_PRODUCTS]: {
            importClass: function () {
                return import('./ShopLayout/ShopLayout.js');
            },
            className: 'ShopLayout'
        },

        // Healthy Fields
        [Alias.HEALTHY_FIELDS_DASHBOARD]: {
            importClass: function () {
                return import('./HealthyFields/HFDashboard/HFDashboard.js');
            },
            className: 'HFDashboard'
        },
        [Alias.HEALTHY_FIELDS_OVERVIEW]: {
            importClass: function () {
                return import('./HealthyFieldsOverviewLayout/HealthyFieldsOverviewLayout.js');
            },
            className: 'HealthyFieldsOverviewLayout'
        },
        [Alias.HEALTHY_FIELDS_SERVICES]: {
            importClass: function () {
                return import('./HealthyFieldsServiceLayout/HealthyFieldsServiceLayout.js');
            },
            className: 'HealthyFieldsServiceLayout'
        },
        [Alias.HEALTHY_FIELDS_REQUEST]: {
            importClass: function () {
                return import('./HealthyFieldsRequestLayout/HealthyFieldsRequestLayout.js');
            },
            className: 'HealthyFieldsRequestLayout'
        },
        [Alias.HEALTHY_FIELDS_CONTRACTOR_REQUEST]: {
            importClass: function () {
                return import('./HealthyFieldsContractorRequestLayout/HealthyFieldsContractorRequestLayout.js');
            },
            className: 'HealthyFieldsContractorRequestLayout'
        },

        // FDL
        [Alias.FIELD_DATA_LAYERS]: {
            importClass: function () {
                return import('./FieldDataLayersLayout/FieldDataLayersLayout.js');
            },
            className: 'FieldDataLayersLayout'
        },

        [Alias.FDL_UPLOADS]: {
            importClass: function () {
                return import('./FDLUploadLayout/FDLUploadLayout.js');
            },
            className: 'FDLUploadLayout'
        },

        [Alias.REGISTRATION_HF_CONTRACTOR]: {
            importClass: function () {
                return import('./HFContractorRegisterLayout/HfContractorRegistrationLayout.js');
            },
            className: 'HFContractorRegistrationLayout'
        },

        // Fields
        [Alias.SHOP_ORDER]: {
            importClass: function () {
                return import('./ShopOrderLayout/ShopOrderLayout.js');
            },
            className: 'ShopOrderLayout'
        },

        //Support
        [Alias.RESET_CACHE]: {
            importClass: function () {
                return import('./ResetCacheLayout/ResetCacheLayout.js');
            },
            className: 'ResetCacheLayout'
        },

        // Login
        [Alias.LOGIN]: {
            importClass: function () {
                return import('./LoginLayout/LoginLayout.js');
            },
            className: 'LoginLayout'
        },
        [Alias.RESET_PASS]: {
            importClass: function () {
                return import('./LoginLayout/LoginLayout.js');
            },
            className: 'LoginLayout'
        },
        [Alias.FORGOT_PASS]: {
            importClass: function () {
                return import('./LoginLayout/LoginLayout.js');
            },
            className: 'LoginLayout'
        },
        [Alias.REGISTRATION]: {
            importClass: function () {
                return import('./RegistrationLayout/RegistrationLayout.js');
            },
            className: 'RegistrationLayout'
        },
        [Alias.REGISTRATION_2019]: {
            importClass: function () {
                return import('./RegistrationLayout/Registration2019Layout.js');
            },
            className: 'Registration2019Layout'
        },
        [Alias.REGISTRATION_HEALTHY_FIELDS]: {
            importClass: function () {
                return import('./RegistrationLayout/RegistrationHealthyFieldsLayout.js');
            },
            className: 'RegistrationHealthyFieldsLayout'
        },
        [Alias.REGISTRATION_HEALTHY_FIELDS_CONTRACTOR]: {
            importClass: function () {
                return import('./RegistrationLayout/RegistrationHealthyFieldsLayout.js');
            },
            className: 'RegistrationHealthyFieldsLayout'
        },
        [Alias.REGISTRATIONS_CLOSED]: {
            importClass: function () {
                return import('./RegistrationsClosedLayout/RegistrationsClosedLayout.js');
            },
            className: 'RegistrationsClosedLayout'
        },

        // Error pages
        [Alias.NOT_AUTHORIZED]: {
            importClass: function () {
                return import('./Error403Layout/Error403Layout.js');
            },
            className: 'Error403Layout'
        },
        [Alias.PAGE_NOT_FOUND]: {
            importClass: function () {
                return import('./Error404Layout/Error404Layout.js');
            },
            className: 'Error404Layout'
        },

        // Under Construction page
        [Alias.UNDER_CONSTRUCTION]: {
            importClass: function () {
                return import('./UnderConstructionLayout/UnderConstructionLayout.js');
            },
            className: 'UnderConstructionLayout'
        },

        // T&C Construction page
        [Alias.TC_ACCEPTED]: {
            importClass: function () {
                return import('./TcAcceptedLayout/TcAcceptedLayout.js');
            },
            className: 'TcAcceptedLayout'
        },

        // Email Verified page
        [Alias.EMAIL_VERIFIED]: {
            importClass: function () {
                return import('./EmailVerifiedLayout/EmailVerifiedLayout.js');
            },
            className: 'EmailVerifiedLayout'
        },

        [Alias.SHOP_PAYMENT_SUCCESS]: {
            importClass: function () {
                return import('./ShopPaymentRedirectionLayout/ShopPaymentRedirectionLayout.js');
            },
            className: 'ShopPaymentRedirectionLayout'
        },
        [Alias.SHOP_PAYMENT_FAILED]: {
            importClass: function () {
                return import('./ShopPaymentRedirectionLayout/ShopPaymentRedirectionLayout.js');
            },
            className: 'ShopPaymentRedirectionLayout'
        }
    }
};

export class LayoutConfig {

    /**
     * Will return a name of the layout that shoul be loadedtaking into account:
     *   - route
     *   - user country
     *
     * @param {RouteEvent} routeEvent
     *
     * @returns {String|undefined}
     */
    static getLayoutClassName (routeEvent) {

        let config = ConfigUtils.getCountryConfig(layoutConfig, routeEvent);

        return config[routeEvent.routeName].className;
    }

    /**
     * Get Layout class app feature to check if enabled
     *
     * @param {RouteEvent} routeEvent
     * @returns {String|undefined}
     */
    static getLayoutClassAppFeature (routeEvent) {

        let config = ConfigUtils.getCountryConfig(layoutConfig, routeEvent);

        return config[routeEvent.routeName].appFeature;
    }

    static importLayoutClass (routeEvent) {

        let config = ConfigUtils.getCountryConfig(layoutConfig, routeEvent);

        return config[routeEvent.routeName].importClass();
    }

    /**
     * @param {Object} routeEvent
     * @returns {jQuery.Deferred}
     */
    static getLayout (routeEvent) {

        let layoutReady = $.Deferred();
        let layoutClassName = LayoutConfig.getLayoutClassName(routeEvent);

        if (layoutClassName) {

            LayoutConfig.importLayoutClass(routeEvent).then(ContentLayout => {

                if (!_.isUndefined(ContentLayout[layoutClassName])) {

                    layoutReady.resolve(ContentLayout[layoutClassName]);
                }
                else {

                    layoutReady.reject('«' + layoutClassName + '» was not exported from the loaded module');
                }

            }).catch(errObj => {

                layoutReady.reject(errObj.message);
                console.error(errObj.message);
                console.error(errObj.stack);
            });
        }
        else {

            layoutReady.reject('Layout for route «' + routeEvent.routeName + '» was not specified.');
        }

        return layoutReady;
    }
}


// WEBPACK FOOTER //
// ./layout/config.js